import React from "react";
import {
    Form, Button, Container, Row, Col, Card, Tab, Tabs,
} from "react-bootstrap";
import "./VendorCLAssignment.css";
import {useState, useEffect, useRef} from "react";
import axios from "../../util/Axios/AxiosInstance";
import {useNavigate} from "react-router-dom";
import Select from "react-select";
// import {encrypt,decrypt} from 'n-krypta';
import makeAnimated from "react-select/animated";
import AOS from "aos";
import "aos/dist/aos.css";

// const string = "encrypt the string";
// const secretKey = "key!";
// const encryptString = encrypt(string,secretKey);
// const decryptString = decrypt(encryptString, secretKey);
//

const animatedComponents = makeAnimated();

function VendorCLAssignment({data}) {
    const [vendorData, setVendorData] = useState(data);

    const navigate = useNavigate();
    // const [selected, setSelected] = useState([]);
    const [show, setShow] = useState([]);

    const [SBselected, SBsetSelected] = useState([]);
    const [SBshow, SBsetShow] = useState([]);

    const [SCselected, SCsetSelected] = useState([]);
    const [SCshow, SCsetShow] = useState([]);

    const [SGselected, SGsetSelected] = useState([]);
    const [SGshow, SGsetShow] = useState([]);

    // const [deptName, setDeptName] = useState([]);

    const [deptList, setDeptList] = useState([]);
    const [subDepartmentList, setSubDeptList] = useState([]);

    // const [shiftId, setShiftId] = useState("");
    const [vendorId, setVendorId] = useState([]);
    const [vendorTransactionMaster, setVendorTransactionMaster] = useState([]);
    const [labourerName, setLabourerName] = useState([]);
    const [labourerId, setLabourerId] = useState([]);

    const [maleEmpData, setMaleEmpData] = useState([]);
    const [maleEmpDetails, setMaleEmpDetails] = useState([]);
    const [femaleEmpData, setFemaleEmpData] = useState([]);
    const [femaleEmpDetails, setFemaleEmpDetails] = useState([]);
    const [empData, setEmpData] = useState([]);
    const [empDetails, setEmpDetails] = useState([]);
    const [vendorTransactionTableData, setVendorTransactionTableData] = useState([{
        labourId: "", labourerName: "", labourerGender: ""
    },]);
    const [selectedMale, setSelectedMale] = useState([]);
    const [selectedFemale, setSelectedFemale] = useState([]);
    const [selectedEmp, setSelectedEmp] = useState([]);
    const [hadExistingData, setHadExistingData] = useState(false);
    const [vendorTransactionExistingData, setVendorTransactionExistingData] = useState();
    const [vendorCLTransaction, setVendorCLTransaction] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [transactionId, setTransactionId] = useState(vendorData.id);
    const [transactionDate, setTransactionDate] = useState("");
    const [shiftId, setShiftId] = useState("");
    const [shiftName, setShiftName] = useState("");
    const [shiftIdTab, setShiftIdTab] = useState("");
    const [showContent, setShowContent] = useState(false);
    const [deptName, setDeptName] = useState(vendorData.deptName);
    const [deptId, setDeptId] = useState(vendorData.deptId);
    const [subDeptName, setSubDeptName] = useState(vendorData.subDeptName);
    const [subDeptId, setSubDeptId] = useState(vendorData.subDeptId);
    const [branchId, setBranchId] = useState(vendorData.branchId);
    const [branchName, setBranchName] = useState(vendorData.branchName);
    const [labourId, setLabourId] = useState("");
    const [labourerGender, setLabourerGender] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [createdDate, setCreatedDate] = useState("");
    const [shiftRef, setShiftRef] = useState({});
    const shiftRefNum = useRef(0);
    const [subDId, setSubDId] = useState(vendorData.subDeptId);
    const [subDName, setSubDName] = useState(vendorData.subDeptName);
    // const shiftRef = useRef({});
    const transactionDt = useRef(0);
    const [tData, setTData] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [vendorDetailsByData, setVendorDetailsByData] = useState([]);
    const [deptDetails, setDeptDetails] = useState([]);
    const [tranDate, setTranDate] = useState([]);
    // const [mName, setMName] = useState([]);
    // const [fName, setFName] = useState([]);
    const mName = useRef([]);
    const fName = useRef([]);
    const empName = useRef([]);
    const labourList = useRef([]);
    // const [shiftRef, setFinalShift] = useState({});
    const [error, setError] = useState(false);
    const [showTabs, setShowTabs] = useState(false);
    const [dataNotAvailable, setDataNotAvailable] = useState(false);
    const [transactionDateSelected, setTransactionDateSelected] = useState(vendorData.transactionDate);
    const [subDeptSelected, setSubDeptSelected] = useState(vendorData.subDeptId);
    const [maleSelectedCount, setMaleSelectedCount] = useState(0);
    const [femaleSelectedCount, setFemaleSelectedCount] = useState(0);
    const [empSelectedCount, setEmpSelectedCount] = useState(0);
    const [selectedMore, setSelectedMore] = useState(false);
    const [savedChanges, setSavedChanges] = useState(true);
    const [showError, setShowError] = useState(false);
    const genderSpecific = localStorage.getItem("genderSpecific");

    useEffect(() => {
        // getDepartmentDetails();
        // getDeptByTransactionDateforVendorDetails();
        // getMasterLabourerDetailsByFemale();
        // getMasterLabourerDetailsByMale();
        getMasterLabourerDetailsByVendorId();

        getVendorDetailsByIds(transactionDateSelected, deptId, subDId);
        return;
    }, []);

    useEffect(() => {
        setShiftRef({});
        for (let i = 0; i < vendorDetailsByData.length; i++) {
            if (vendorDetailsByData[i].shiftId == shiftIdTab) {
                setShiftRef(vendorDetailsByData[i]);
                // shiftRef.current = vendorDetailsByData[i];
                setShowContent(true);

                return;
            }
        }
        setShowContent(false);
    }, [vendorDetailsByData, shiftIdTab]);

    useEffect(() => {
    }, [shiftRef, selectedMale, selectedFemale]);

    useEffect(() => {
        AOS.init();
        getShiftDetails();
    }, []);

    const getVendorDetailsByIds = (transactionDate, deptId, subDeptId) => {
        //
        const vendorId = localStorage.getItem("vendorId") | vendorData.vendorId;
        axios
            .get("getVendorDetailsByIds/" + transactionDate + "/" + deptId + "/" + subDeptId + "/" + vendorId)
            .then((data) => {
                if (data.status === 200) {
                    const vendorDetByData = data.data;
                    setVendorDetailsByData(vendorDetByData);
                    if (vendorDetByData.length > 0) {
                        setShowTabs(true);
                        setDataNotAvailable(false);
                    } else {
                        setDataNotAvailable(true);
                        setShowTabs(false);
                    }
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const getVendorTransactionDetailsByIds = (transactionDate, deptId, subDeptId, shiftId) => {
        //
        const vendorId = localStorage.getItem("vendorId") | vendorData.vendorId;
        axios
            .get("getVendorCLTransactionDetailsByIds/" + transactionDate + "/" + deptId + "/" + subDeptId + "/" + vendorId + "/" + shiftId)
            .then((data) => {
                if (data.status === 200) {
                    const vendorTransactionDetByData = data.data;
                    setVendorTransactionTableData(vendorTransactionDetByData);

                    let maleArray = [];
                    let femaleArray = [];
                    let empArray = [];
                    if (vendorTransactionDetByData.length > 0) {
                        setHadExistingData(true);
                        setVendorTransactionExistingData(false);

                        for (let i = 0; i < vendorTransactionDetByData.length; i++) {
                            empArray.push({
                                label: vendorTransactionDetByData[i].labourerName,
                                value: vendorTransactionDetByData[i].labourId,
                            });
                            if (vendorTransactionDetByData[i].labourerGender == "MALE" || vendorTransactionDetByData[i].labourerGender == "male" || vendorTransactionDetByData[i].labourerGender == "Male") {
                                maleArray.push({
                                    label: vendorTransactionDetByData[i].labourerName,
                                    value: vendorTransactionDetByData[i].labourId,
                                });
                            } else {
                                femaleArray.push({
                                    label: vendorTransactionDetByData[i].labourerName,
                                    value: vendorTransactionDetByData[i].labourId,
                                });
                            }
                        }
                        setSelectedMale(maleArray);
                        setSelectedFemale(femaleArray);
                        setSelectedEmp(empArray);
                        // const maleEmployees = vendorTransactionTableData.filter((maledata) => {return maledata.labourerGender === 'male' || maledata.labourerGender === 'MALE';} );
                        // setSelectedMale(maleEmployees);
                        //
                        // const femaleEmployees = vendorTransactionTableData.filter((femaledata) => {return femaledata.labourerGender === 'female' || femaledata.labourerGender === 'FEMALE';} );
                        // setSelectedMale(femaleEmployees);
                        //
                        //
                        //
                    } else {
                        setHadExistingData(false);
                        setSelectedMale(maleArray);
                        setSelectedFemale(femaleArray);
                        setSelectedEmp(empArray);
                        setVendorTransactionExistingData(true);
                    }
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const getDepartmentDetails = () => {
        axios
            .get("getDepartmentDetails")
            .then((data) => {
                if (data.status === 200) {
                    const newData = data.data;
                    setDeptList(newData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getVendorTransactionDetailsByShiftId = (shiftId) => {
        axios
            .get("getVendorTransactionDetailsByShiftId/" + shiftId)
            .then((data) => {
                if (data.status === 200) {
                    const shiftData = data.data;

                    setShiftList(shiftData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getDeptByTransactionDateforVendorDetails = (transactionDate) => {
        //
        axios
            .get("getDeptByTransactionDateforVendorDetails/" + transactionDate)
            .then((data) => {
                if (data.status === 200) {
                    const deptVendorDet1 = data.data;
                    setDeptDetails(deptVendorDet1);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };


    const getShiftDetails = () => {
        axios
            .get("getShiftDetails")
            .then((data) => {
                if (data.status === 200) {
                    const shiftData1 = data.data;
                    setShiftData(shiftData1);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getVendorCLTransactionDetailByShiftSubDeptDept = () => {
        //
        axios
            .get("getVendorCLTransactionDetailByShiftSubDeptDept/" + shiftRefNum.current + "/" + subDeptId + "/" + deptId)
            .then((data) => {
                if (data.status === 200) {
                    const fetchData1 = data.data;
                    setTData(fetchData1);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getMasterLabourerDetailsByVendorId = () => {
        const branchId = localStorage.getItem("branchId");
        const vendorId = localStorage.getItem("vendorId") | data.vendorId;
        axios
            .get("getMasterLabourerDetailsByBranchAndVendorId" + "/" + branchId + "/" + vendorId)
            .then((data1) => {
                if (data1.status === 200) {
                    const empDataList = data1.data;
                    setEmpData(empDataList);
                    for (let i = 0; i < empDataList.length; i++) {
                        empDetails.push({
                            label: empDataList[i].labourName, value: empDataList[i].labourId,
                        });
                        if (empDataList[i].gender == "male" || empDataList[i].gender == "Male" || empDataList[i].gender == "MALE") {
                            maleEmpDetails.push({
                                label: empDataList[i].labourName, value: empDataList[i].id,
                            });
                        } else {
                            femaleEmpDetails.push({
                                label: empDataList[i].labourName, value: empDataList[i].id,
                            });
                        }
                    }
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const getMasterLabourerDetailsByMale = () => {
        const vendorId = localStorage.getItem("vendorId");
        axios
            .get("getMasterLabourerDetailsByGenderAndVendorId/male/" + vendorId)
            .then((data1) => {
                if (data1.status === 200) {
                    const maleEmpDataList = data1.data;
                    setMaleEmpData(maleEmpDataList);
                    // setMaleEmpDetails
                    for (let i = 0; i < maleEmpDataList.length; i++) {
                        // setMaleEmpDetails([...maleEmpDetails, x])
                        maleEmpDetails.push({
                            label: maleEmpDataList[i].labourName, value: maleEmpDataList[i].labourId,
                        });
                        empDetails.push({
                            label: maleEmpDataList[i].labourName, value: maleEmpDataList[i].labourId,
                        });
                    }
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const getMasterLabourerDetailsByFemale = () => {
        const vendorId = localStorage.getItem("vendorId");
        axios
            .get("getMasterLabourerDetailsByGenderAndVendorId/female/" + vendorId)
            .then((data1) => {
                if (data1.status === 200) {
                    const femaleEmpData = data1.data;
                    setFemaleEmpData(femaleEmpData);
                    for (let i = 0; i < femaleEmpData.length; i++) {
                        // setMaleEmpDetails([...maleEmpDetails, x])
                        femaleEmpDetails.push({
                            label: femaleEmpData[i].labourName, value: femaleEmpData[i].labourId,
                        });
                        empDetails.push({
                            label: femaleEmpData[i].labourName, value: femaleEmpData[i].labourId,
                        });
                    }
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    var currentdate = new Date();
    var datetime = currentdate.getFullYear() + "-" + (currentdate.getMonth() + 1) + "-" + currentdate.getDate() + " ";
    // + currentdate.getHours() + ":"
    // + currentdate.getMinutes() + ":"
    // + currentdate.getSeconds();
    const vendorCLDataAdd = {
        transactionId: vendorDetailsByData.transactionId,
        transactionDate: transactionDt.current,
        shiftId: "Shift A",
        deptName: vendorDetailsByData.deptName,
        deptId: deptId,
        subDeptName: vendorDetailsByData.subDeptName,
        subDeptId: subDeptId,
        labourId: "1",
        labourerGender: "Male",
        createdBy: "Vendor",
        createdDate: datetime,
    };

    let handleCLVendorSubmitForm = async (e) => {
        e.preventDefault();
        axios
            .post("addVendorTransactionMasterDetails", vendorCLDataAdd)
            .then((data) => {
                if (data.status === 200) {
                    // vendorCLData.TransactionId = data.data.TransactionId;
                    // setDeptVendorDataAdd(vendorCLData);
                    //
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const onSelectDate = (e) => {
        transactionDt.current = e.target.value;

        setTransactionDateSelected(e.target.value);
        setShowTabs(false);
        setDataNotAvailable(false);
        // getDeptByTransactionDateforVendorDetails(transactionDt.current);
    };

    const onProceed = (e) => {
        e.preventDefault();
        if (maleSelectedCount > shiftRef.maleCount || (maleSelectedCount == 0 && femaleSelectedCount == 0 && empSelectedCount == 0) || femaleSelectedCount > shiftRef.femaleCount || empSelectedCount > shiftRef.vendorAssignedTotalCount) {
            setSelectedMore(true);

            return;
        }
        setVendorTransactionExistingData(false);

        setSavedChanges(true);
        setShowError(false);
        if (genderSpecific == "true") {
            for (let male of mName.current) {
                labourList.current.push(male.value.toString());
            }
            for (let female of fName.current) {
                labourList.current.push(female.value.toString());
            }
        } else {
            for (let empData of empName.current) {
                labourList.current.push(empData.value.toString());
            }
        }

        const vendorId = localStorage.getItem("vendorId") | vendorData.vendorId;
        const vendorName = localStorage.getItem("username");
        const addVendorTransactionDetailsData = {
            vendorTransactionId: transactionId,
            transactionDate: transactionDateSelected,
            shiftId: shiftIdTab,
            shiftName: shiftName,
            deptId: deptId, // deptName: deptName,
            subDeptId: subDId, // subDeptName: subDName,
            totalEmpCount: 10,
            vendorId: vendorId, // vendorName: vendorName,
            labourList: labourList.current,
            createdBy: vendorName,
            branchId: branchId, // branchName: branchName
        };

        axios
            .post("addVendorCLTransactionDetails", addVendorTransactionDetailsData)
            .then((data) => {
                if (data.status === 200) {
                    setVendorTransactionExistingData(false);
                    setHadExistingData(true);
                    mName.current = [];
                    fName.current = [];
                    empName.current = [];
                    labourList.current = [];
                } else {
                }
            })
            .catch((error) => {
                setVendorTransactionExistingData(true);
                console.error(error);
            });
    };

    // const onSelectDept = (e) => {
    //   setDeptId(e.target.value);
    //   setDeptName(e.target.selectedOptions[0].id);
    //   setShowTabs(false);
    //   setDataNotAvailable(false);
    //   getSubDepartmentDetailsbyDeptID(e.target.value);
    // }

    // const onSelectSubDept = (e) => {
    //   subDName.current = e.target.selectedOptions[0].id;
    //   subDId.current = e.target.value;
    //   setSubDeptSelected(e.target.value);
    //   setShowTabs(false);
    //   setDataNotAvailable(false);
    //   // setSubDeptId(e.target.value);
    //   // getShiftDetails();
    //   // getVendorDetailsByIds(transactionDt.current, deptId, subDId.current);
    // }

    let getAssignedDataByDateDeptSubDept = async (e) => {
        if (transactionDateSelected == "" || deptId == "" || subDeptSelected == "") {
            setError(true);
            return;
        }
        shiftRefNum.current = "";
        setShiftIdTab("");

        getVendorDetailsByIds(transactionDt.current, deptId, subDId.current);
    };

    const empDt = (e) => {
        setEmpSelectedCount(e.length);
        setSelectedMore(false);
        setSavedChanges(false);
        setShowError(false);
        empName.current = e;
        setSelectedEmp(e);
    };

    const maleEmpDt = (e) => {
        // setMName(e);
        console.log(e)

        setMaleSelectedCount(e.length);
        setSelectedMore(false);
        setSavedChanges(false);
        setShowError(false);
        mName.current = e;
        setSelectedMale(e);
    };
    const femaleEmpDt = (e) => {
        // setMName(e);
        setFemaleSelectedCount(e.length);
        setSelectedMore(false);
        setSavedChanges(false);
        setShowError(false);
        fName.current = e;
        setSelectedFemale(e);
    };

    const OnSelectshift = (e) => {
        if (savedChanges == false && (maleSelectedCount != 0 || femaleSelectedCount != 0)) {
            setShowError(true);

            return;
        }

        getVendorTransactionDetailsByIds(transactionDateSelected, deptId, subDId, e);
        //
        //
        //
        //
        //
        shiftRefNum.current = e;
        setShiftIdTab(e);
    };

    const onSelectShiftName = (e) => {
        if (savedChanges == false && (maleSelectedCount != 0 || femaleSelectedCount != 0)) {
            setShowError(true);
            return;
        }
        setShiftName(e.target.value);
    };

    return (<Container fluid className="px-0">
        <div className="">
            <div className="mt-2">
                {/*<h2 className='Title'>Vendor CL Assignment</h2>*/}
                <h5 className={"priColor"}>Vendor CL Assignment</h5>
            </div>
            <div data-aos="zoom-in-right" data-aos-duration="450">
                <Form onSubmit={handleCLVendorSubmitForm}>
                    <Card className="cardStyl">
                        <div>
                            <div className="container">
                                <div className="row pb-4">
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <Form.Label column className="control-label, textBold">
                                            Date{" "}
                                        </Form.Label>
                                        <Col>
                                            <Form.Control
                                                disabled
                                                type="date"
                                                placeholder="Enter here.."
                                                value={transactionDateSelected}
                                            />
                                        </Col>
                                        {/* <Form.Label column className="control-label, textBold">Date  </Form.Label>
                      <Col >
                        <Form.Control type="date" onChange={e => onSelectDate(e)} placeholder="Enter here.." />
                      {error && transactionDateSelected == '' ?
                       <label className="requiredValidation">Please Select Date</label>:""
                      }
                      </Col> */}
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <Form.Label column className="control-label, textBold">
                                            Department{" "}
                                        </Form.Label>
                                        <Col>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                placeholder="Dept Name"
                                                value={deptName}
                                            />
                                        </Col>
                                        {/* <Form.Label column className="control-label, textBold">Department  </Form.Label>
                      <Col>
                        <Form.Select
                          // name="Countries"
                          onChange={e => onSelectDept(e)}
                        // value={deptList}
                        >
                          <option value="">Select the Dept</option>
                          {
                            deptList.map(dept => (
                              <option key={dept.department_id}
                                      value={dept.department_id}
                                      id={dept.department_name}
                              >
                                {dept.department_name}
                              </option>
                            ))}
                        </Form.Select>
                        {error && deptId == '' ?
                       <label className="requiredValidation">Please Select Dept</label>:""
                      } */}

                                        {/* {errors.Dept && <p className="RequiredFields">Please Select Dept</p>} */}
                                        {/* </Col> */}
                                    </div>
                                    <div className="col-lg-5 col-md-5 col-sm-12">
                                        <Form.Label column className="control-label, textBold">
                                            Sub-Department{" "}
                                        </Form.Label>
                                        <Col>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                placeholder="Sub-Dept Name"
                                                value={subDName}
                                            />
                                        </Col>
                                        {/* <Form.Label column className="control-label, textBold">Sub-Department</Form.Label>
                      <Col>
                        <Form.Select
                          aria-label="Default select example"
                          placeholder='Select Sub-Department'
                          onChange={e => onSelectSubDept(e)}
                        >

                          <option>Select Sub-Department</option>
                          {
                            subDepartmentList.map(subDept => (
                              <option value={subDept.subDepartmentId} id={subDept.subDepartmentName}>
                                {subDept.subDepartmentName}
                              </option>
                              // <option value="2">Vendor-2</option>
                              // <option value="3">Vendor-3</option>
                            ))}
                        </Form.Select>
                        {error && subDeptSelected == '' ?
                       <label className="requiredValidation">Please Select Sub-Dept</label>:""
                      }
                      </Col> */}
                                    </div>
                                    {/* <div className="col-lg-3 col-md-3 col-sm-12">
                      <Col className="SearchButton"><Button variant="primary" type="button" onClick={(e) => getAssignedDataByDateDeptSubDept(e)}> Search </Button></Col>
                    </div> */}
                                </div>
                            </div>
                            {dataNotAvailable === true && showTabs === false ? (
                                <h5 className="warningMessage">No Data Available</h5>) : ("")}
                            {showTabs === true && shiftData.length>0 && (<div className="container, PillsBackground p-2 mb-4">
                                <Tabs
                                    defaultActiveKey={shiftIdTab}
                                    activeKey={shiftIdTab}
                                    justify
                                    variant="pills"
                                    onSelect={(e) => OnSelectshift(e)}
                                >
                                    {/* {vendorDetailsByData.map(shift => ( */}
                                    {shiftData.map((shift) => (<Tab
                                            eventKey={shift.shiftId}
                                            title={shift.shiftName}
                                            key ={shift.shiftId}
                                            value={shift.shiftName}
                                            // title={<>
                                            //     <Button
                                            //         className={"transparentButton"}
                                            //         value={shift.shiftName}
                                            //         onClick={(e) => onSelectShiftName(e)}
                                            //     >
                                            //         {shift.shiftName}
                                            //     </Button>
                                            // </>}
                                            className="active-content"
                                        ></Tab>
                                        // ))
                                        // }
                                    ))}
                                </Tabs>
                                {showError == true && (<h6
                                    style={{textAlign: "center"}}
                                    className="requiredValidation"
                                >
                                    Submit all the Changes.
                                </h6>)}
                                {showContent == true && (<div>
                                    <Card className="cardStyl">
                                        <div>
                                            {/*<h5 className="ShiftTitle">{shiftName}</h5>*/}
                                            <h5 className="ShiftTitle">{shiftRef.shiftName}</h5>
                                            <Row className="mb-3">
                                                <Col md={6} sm={12} xl={6} lg={6}>
                                                    <Row>
                                                        <Form.Label
                                                            column
                                                            md={5}
                                                            sm={5}
                                                            xl={5}
                                                            lg={5}
                                                            className="textBold"
                                                        >
                                                            Total Emp Required
                                                        </Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                type="text"
                                                                disabled
                                                                placeholder={shiftRef.vendorAssignedTotalCount}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {genderSpecific == "false" ? (<Col md={6} sm={12} xl={6} lg={6}>
                                                    <Row>
                                                        <Form.Label
                                                            column
                                                            md={5}
                                                            sm={5}
                                                            xl={5}
                                                            lg={5}
                                                            className="textBold"
                                                        >
                                                            Select Emp
                                                        </Form.Label>
                                                        <Col>
                                                            <Select
                                                                closeMenuOnSelect={false}
                                                                components={animatedComponents}
                                                                isMulti
                                                                options={empDetails}
                                                                value={selectedEmp}
                                                                isDisabled={hadExistingData}
                                                                onChange={(e) => empDt(e)}
                                                            />
                                                            {selectedMore && empSelectedCount > shiftRef.vendorAssignedTotalCount ? (
                                                                <label className="requiredValidation">
                                                                    Limit Exceeded
                                                                </label>) : ("")}
                                                        </Col>
                                                    </Row>
                                                </Col>) : ("")}
                                            </Row>
                                            {genderSpecific == "true" ? (<Row className="mb-3">
                                                <Col md={6} sm={12} xl={6} lg={6}>
                                                    <Row>
                                                        <Form.Label
                                                            column
                                                            md={5}
                                                            sm={5}
                                                            xl={5}
                                                            lg={5}
                                                            className="textBold"
                                                        >
                                                            Total Male
                                                        </Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                type="text"
                                                                disabled
                                                                placeholder={shiftRef.maleCount}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md={6} sm={12} xl={6} lg={6}>
                                                    <Row>
                                                        <Form.Label
                                                            column
                                                            md={5}
                                                            sm={5}
                                                            xl={5}
                                                            lg={5}
                                                            className="textBold"
                                                        >
                                                            {" "}
                                                            Total Female
                                                        </Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                type="text"
                                                                disabled
                                                                placeholder={shiftRef.femaleCount}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>) : ("")}
                                            {genderSpecific == "true" ? (<Row className="mb-3">
                                                <Col md={6} sm={12} xl={6} lg={6}>
                                                    <Row>
                                                        <Form.Label
                                                            column
                                                            md={5}
                                                            sm={5}
                                                            xl={5}
                                                            lg={5}
                                                            className="textBold"
                                                        >
                                                            Select Male Emp
                                                        </Form.Label>
                                                        {/* <pre>{JSON.stringify(selected)}</pre> */}
                                                        <Col>
                                                            {/* <MultiSelect options={setMaleEmpData}
                                      value={selected}
                                      onChange={setSelected}
                                      labelledBy="Select" /> */}
                                                            {/* <MultiSelect
                                          options={maleEmpDetails}
                                          value={selected}
                                          onChange={setSelected}
                                          labelledBy="Select"
                                        /> */}

                                                            <Select
                                                                closeMenuOnSelect={false}
                                                                components={animatedComponents}
                                                                isMulti
                                                                options={maleEmpDetails}
                                                                value={selectedMale}
                                                                isDisabled={hadExistingData}
                                                                onChange={(e) => maleEmpDt(e)}
                                                            />
                                                            {selectedMore && maleSelectedCount > shiftRef.maleCount ? (
                                                                <label className="requiredValidation">
                                                                    Limit Exceeded
                                                                </label>) : ("")}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md={6} sm={12} xl={6} lg={6}>
                                                    <Row>
                                                        <Form.Label
                                                            column
                                                            md={5}
                                                            sm={5}
                                                            xl={5}
                                                            lg={5}
                                                            className="textBold"
                                                        >
                                                            {" "}
                                                            Select Female Emp
                                                        </Form.Label>
                                                        <Col>
                                                            {/* <MultiSelect
                                          options={femaleEmpDetails}
                                          value={show}
                                          onChange={setShow}
                                          labelledBy="Select"
                                        /> */}
                                                            <Select
                                                                closeMenuOnSelect={false}
                                                                components={animatedComponents}
                                                                isMulti
                                                                options={femaleEmpDetails}
                                                                isDisabled={hadExistingData}
                                                                onChange={(e) => femaleEmpDt(e)}
                                                                value={selectedFemale}
                                                                // onChange={setSelected}
                                                            />
                                                            {selectedMore && femaleSelectedCount > shiftRef.femaleCount ? (
                                                                <label className="requiredValidation">
                                                                    Limit Exceeded
                                                                </label>) : ("")}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>) : ("")}
                                            {selectedMore && maleSelectedCount == 0 && femaleSelectedCount == 0 && empSelectedCount == 0 ? (
                                                <h6
                                                    style={{textAlign: "center"}}
                                                    className="requiredValidation"
                                                >
                                                    Please Select Employees before Submitting.
                                                </h6>) : ("")}
                                        </div>
                                    </Card>
                                </div>)}
                                {shiftIdTab != "" && showContent == false && (<div>
                                    <Card className="cardStyl">
                                        <div>
                                            <h6 className="ShiftTitle">
                                                No Task Assigned for this Shift
                                            </h6>
                                        </div>
                                    </Card>
                                </div>)}
                            </div>)}
                        </div>
                        {showTabs && showContent && (<div className="SaveCancelButtonDiv">
                            <div className="container">
                                <div className="row">
                                    <div className="text-right">
                                        {/* <button type="button" className="btn btn-primary float-end mx-2">Cancel</button> */}
                                        <button
                                            disabled={!vendorTransactionExistingData}
                                            onClick={(e) => onProceed(e)}
                                            type="submit"
                                            className="btn btn-success float-end"
                                        >
                                            Proceed
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </Card>
                </Form>
            </div>
        </div>
    </Container>);
}

export default VendorCLAssignment;
